import React from "react";
import { Avatar, Empty, Spin, Typography } from "antd";
import { debounce } from "lodash";
import { UserSelectContainer, UserSelect, UserSelectOption, Circle } from "./styles";
import { NOT_FOUND_TEXT } from "../../utils/constants";
import { SearchOutlined } from "@ant-design/icons";

interface User {
    id: string;
    fullName: string;
    email: string;
	profilePhoto?: string | null
}

interface UserSelectComponentProps {
    title?: string;
    isRequired?: boolean;
    selectedUser?: User | null;
    searchText?: string;
    searchingUser?: boolean;
    searchResult: User[];
    onSelectUser?: (value: string) => void;
    onSearchUser: (value: string) => void;
    style?: React.CSSProperties;
    placeholder?: string;

}

const UserSelectComponent: React.FC<UserSelectComponentProps> = ({
	title,
	selectedUser,
	searchText,
	searchingUser,
	isRequired = false,
	searchResult,
	onSelectUser,
	onSearchUser,
	style,
	placeholder = "Lütfen seçiniz",

}) => {
	const debouncedSearch = debounce((value: string) => {
		if (value.length >= 3) {
			onSearchUser(value);
		}
	}, 500);

	return (
		<UserSelectContainer>
			{title && (
				<Typography.Title level={5} style={{ color: "#2e333e" }}>
					{title} {isRequired && <span style={{ color: "red" }}>&nbsp;*</span>}
				</Typography.Title>
			)}
			<UserSelect
				showSearch
				value={selectedUser ? selectedUser.fullName : searchText}
				defaultActiveFirstOption={false}
				filterOption={false}
				onSearch={debouncedSearch}
				suffixIcon={<SearchOutlined />}
				onChange={onSelectUser as any}
				style={style}
				placeholder={placeholder}
				notFoundContent={
					searchingUser ? (
						<div style={{ textAlign: "center", paddingTop: "20px", paddingBottom: "20px" }}>
							<Spin size="small" />
						</div>
					) : searchText && searchResult.length === 0 ? (
						<Empty description={NOT_FOUND_TEXT} />
					) : null
				}		>
				{searchResult.map((person) => (
					<UserSelectOption
						key={person.id}
						value={person.id.toString()}
					>
						<div style={{ display: "flex", alignItems: "center" }}>
							{person?.profilePhoto ? (
								<Circle $backgroundPhoto={person?.profilePhoto} />
							) : (
								<Circle>
									{person.fullName.split(" ").map(name => name[0]).join("")}
								</Circle>
							)}
							<div style={{ marginLeft: "8px", flexGrow: 1 }}>
								<div style={{ fontWeight: "bold" }}>
									{person.fullName}
								</div>
								<div>{person.email}</div>
							</div>
						</div>
					</UserSelectOption>
				))}
			</UserSelect>
		</UserSelectContainer>
	);
};

export default UserSelectComponent;
